/* design-light · navx (Header B) behavior overrides — durable layer.
   Loaded (deferred) from snippets/dl-head.liquid. Runs before dl-navx.js. */
(function(){
  var mq = window.matchMedia('(max-width:1023px)');

  /* Brand logos: inject collections' logo images into wordmark-fallback tiles. */
  var CDN = 'https://cdn.shopify.com/s/files/1/1019/3852/8590/collections/';
  var LOGOS = {
    'artemide': CDN + 'artemide-logo-png-transparent.png?v=1779189617',
    'grau': CDN + 'GRAU_Logo_Black_Clear-Space_RGB_2022-2.png?v=1779190620',
    'ingo-maurer': CDN + 'ingo-maurer-logo_png.webp?v=1779189645',
    'santacole': CDN + 'logo-santa-cole-alt.png?v=1779197787',
    'creative-cables': CDN + 'CA_logo_orizzontale_negativo_png.png?v=1779200622',
    'vitae': CDN + 'vitae-orange-logo.svg?v=1780048895',
    'spectrasol': CDN + 'logo-15.png?v=1779203967'
  };
  Array.prototype.forEach.call(document.querySelectorAll('.navx-btile'), function(tile){
    var word = tile.querySelector('.word');
    if(!word){ return; }
    var href = tile.getAttribute('href') || '';
    var parts = href.split('/collections/');
    if(parts.length < 2){ return; }
    var handle = parts[1].split('?')[0].split('#')[0];
    if(handle.slice(-1) === '/'){ handle = handle.slice(0, -1); }
    var url = LOGOS[handle];
    if(!url){ return; }
    var img = document.createElement('img');
    img.src = url; img.alt = word.textContent; img.loading = 'lazy';
    word.parentNode.replaceChild(img, word);
  });

  /* Mobile drawer logo -> homepage. */
  var dlogo = document.querySelector('.navx-drawer .hd .navx-logo');
  if(dlogo){ dlogo.addEventListener('click', function(){ window.location.href = '/'; }); }

  /* Move burger + search icon into the red utility bar on mobile; restore on desktop. */
  function placeHeader(){
    var util = document.querySelector('.navx-util');
    if(!util){ return; }
    var burger = document.querySelector('[data-navx] .navx-burger');
    var find = document.querySelector('[data-navx] .navx-find');
    var tools = util.querySelector('.tools');
    var catbar = document.querySelector('.navx-catbar');
    if(mq.matches){
      if(burger && burger.parentNode !== util){ util.insertBefore(burger, util.firstChild); }
      if(find && tools && find.parentNode !== util){ util.insertBefore(find, tools); }
    } else if(catbar){
      if(find && find.parentNode !== catbar){ catbar.appendChild(find); }
      if(burger && burger.parentNode !== catbar){ catbar.appendChild(burger); }
    }
  }
  placeHeader();
  if(mq.addEventListener){ mq.addEventListener('change', placeHeader); }
  else if(mq.addListener){ mq.addListener(placeHeader); }
  document.addEventListener('DOMContentLoaded', placeHeader);

  /* ===== Mobile unified search-in-drawer ===== */
  (function(){
    var drawer = document.querySelector('.navx-drawer');
    var bd = drawer && drawer.querySelector('.bd');
    if(!drawer || !bd){ return; }

    var PH = 'Hledejte svítidla, značky nebo místnosti…';
    var si = document.querySelector('[data-navx-search] [data-search-input]');
    if(si && si.getAttribute('placeholder')){ PH = si.getAttribute('placeholder'); }

    function esc(s){ return (s == null ? '' : String(s)).replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }
    function money(v){ if(v == null || v === ''){ return ''; } var n = parseFloat(v); if(isNaN(n)){ return esc(v); } return Math.round(n).toLocaleString('cs-CZ') + ' Kč'; }

    var wrap = document.createElement('div');
    wrap.className = 'dl-dsearch';
    var field = document.createElement('div');
    field.className = 'dl-dsearch-field';
    field.innerHTML = '<svg class="ic" viewBox="0 0 24 24"><circle cx="11" cy="11" r="7"></circle><path d="m21 21-4.3-4.3"></path></svg>';
    var input = document.createElement('input');
    input.type = 'search'; input.className = 'dl-dsearch-input'; input.placeholder = PH;
    input.autocomplete = 'off'; input.setAttribute('enterkeyhint', 'search');
    var clear = document.createElement('button');
    clear.type = 'button'; clear.className = 'dl-dsearch-clear'; clear.setAttribute('aria-label', 'Smazat'); clear.hidden = true;
    field.appendChild(input); field.appendChild(clear);

    /* curated empty-state suggestions */
    var CHIPS = [
      ['Závěsná svítidla', '/collections/zavesna-svitidla'],
      ['Stolní lampy', '/collections/stolni-lampy'],
      ['LED žárovky', '/collections/led-zarovky'],
      ['Textilní kabely', '/collections/creative-cables-elektricke-kabely'],
      ['Ikony', '/collections/ikony']
    ];
    var suggest = document.createElement('div');
    suggest.className = 'dl-dsearch-suggest';
    suggest.innerHTML = '<div class="dl-dsearch-sec">Oblíbené kategorie</div><div class="dl-dsearch-chips">' +
      CHIPS.map(function(c){ return '<a class="dl-dsearch-chip" href="' + c[1] + '">' + esc(c[0]) + '</a>'; }).join('') +
      '</div><div class="dl-dsearch-sec">Oblíbené produkty</div><div class="dl-dsearch-feat"></div>';

    var results = document.createElement('div');
    results.className = 'dl-dsearch-results'; results.hidden = true;
    wrap.appendChild(field); wrap.appendChild(suggest); wrap.appendChild(results);
    bd.insertBefore(wrap, bd.firstChild);

    var featLoaded = false;
    function loadFeatured(){
      if(featLoaded){ return; }
      featLoaded = true;
      fetch('/collections/ikony/products.json?limit=4', { headers: { 'Accept': 'application/json' } })
        .then(function(r){ return r.json(); })
        .then(function(d){
          var feat = suggest.querySelector('.dl-dsearch-feat');
          if(!feat){ return; }
          var h = '';
          (d.products || []).slice(0,4).forEach(function(p){
            var img = (p.images && p.images[0] && p.images[0].src) || '';
            var v = p.variants && p.variants[0];
            h += '<a class="dl-dsearch-prod" href="/products/' + p.handle + '"><span class="th">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</span><span class="tx"><span class="br">' + esc(p.vendor || '') + '</span><span class="nm">' + esc(p.title) + '</span><span class="pr">' + (v ? money(v.price) : '') + '</span></span></a>';
          });
          feat.innerHTML = h;
        })
        .catch(function(){});
    }

    var t = null, lastReq = 0;
    function setSearching(on){ drawer.classList.toggle('dl-searching', on); }
    function reset(){ input.value = ''; clear.hidden = true; setSearching(false); results.hidden = true; results.innerHTML = ''; }

    function render(q, data){
      var r = (data && data.resources && data.resources.results) || {};
      var prods = r.products || [], colls = r.collections || [];
      var h = '';
      if(colls.length){ h += '<div class="dl-dsearch-sec">Kolekce</div>'; colls.slice(0,3).forEach(function(c){ h += '<a class="dl-dsearch-coll" href="' + c.url + '">' + esc(c.title) + '</a>'; }); }
      if(prods.length){
        h += '<div class="dl-dsearch-sec">Produkty</div>';
        prods.slice(0,6).forEach(function(p){
          var img = (p.featured_image && p.featured_image.url) || p.image || '';
          var pr = money(p.price);
          if(p.price_max && p.price_min && p.price_max !== p.price_min){ pr = 'od ' + money(p.price_min); }
          h += '<a class="dl-dsearch-prod" href="' + p.url + '"><span class="th">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</span><span class="tx"><span class="br">' + esc(p.vendor || '') + '</span><span class="nm">' + esc(p.title) + '</span><span class="pr">' + pr + '</span></span></a>';
        });
      }
      if(!prods.length && !colls.length){ h = '<div class="dl-dsearch-empty">Pro tento dotaz jsme nic nenašli.</div>'; }
      h += '<a class="dl-dsearch-all" href="/search?q=' + encodeURIComponent(q) + '&type=product">Všechny výsledky →</a>';
      results.innerHTML = h;
    }

    function onInput(){
      var q = input.value.trim(); clear.hidden = !q; clearTimeout(t);
      if(!q){ setSearching(false); results.hidden = true; results.innerHTML = ''; return; }
      setSearching(true); results.hidden = false;
      t = setTimeout(function(){
        var id = ++lastReq;
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=query,collection,product&resources[limit]=6&resources[options][unavailable_products]=last', { headers: { 'Accept': 'application/json' } })
          .then(function(r){ return r.json(); })
          .then(function(d){ if(id === lastReq){ render(q, d); } })
          .catch(function(){ if(id === lastReq){ results.innerHTML = '<div class="dl-dsearch-empty">Vyhledávání je dočasně nedostupné.</div>'; } });
      }, 180);
    }
    input.addEventListener('input', onInput);
    input.addEventListener('keydown', function(e){ if(e.key === 'Enter'){ var q = input.value.trim(); if(q){ window.location.href = '/search?q=' + encodeURIComponent(q) + '&type=product'; } } });
    clear.addEventListener('click', function(){ reset(); input.focus(); });

    var backdrop = document.createElement('div');
    backdrop.className = 'dl-drawer-backdrop';
    document.body.appendChild(backdrop);
    function openDrawer(focus){ drawer.classList.add('open'); backdrop.classList.add('show'); loadFeatured(); if(focus){ setTimeout(function(){ input.focus(); }, 90); } }
    function closeDrawer(){ drawer.classList.remove('open'); backdrop.classList.remove('show'); reset(); }
    backdrop.addEventListener('click', closeDrawer);
    var xbtn = drawer.querySelector('.hd .x');
    if(xbtn){ xbtn.addEventListener('click', closeDrawer); }
    var burger = document.querySelector('[data-navx] .navx-burger');
    if(burger){ burger.addEventListener('click', function(){ if(mq.matches){ backdrop.classList.add('show'); loadFeatured(); } }); }

    document.addEventListener('click', function(e){
      if(!mq.matches){ return; }
      var b = e.target.closest && e.target.closest('[data-search-open], .navx-find');
      if(!b){ return; }
      e.preventDefault(); e.stopPropagation();
      openDrawer(true);
    }, true);
  })();

  /* Desktop search takeover ✕: clear text if any, else close. */
  document.addEventListener('click', function(e){
    if(mq.matches){ return; }
    var btn = e.target.closest && e.target.closest('[data-navx-search] [data-search-close]');
    if(!btn){ return; }
    var input = document.querySelector('[data-navx-search] [data-search-input]');
    if(input && input.value.trim() !== ''){
      e.stopPropagation(); e.preventDefault();
      input.value = '';
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.focus();
    }
  }, true);

  /* Desktop: click dimmed area outside the search panel to close the takeover. */
  document.addEventListener('click', function(e){
    if(mq.matches){ return; }
    var s = document.querySelector('[data-navx-search]');
    if(!s || s.hidden){ return; }
    if(e.target.closest('.navx-search-in')){ return; }
    s.classList.remove('open');
    document.body.style.overflow = '';
    setTimeout(function(){ s.hidden = true; }, 200);
  }, true);
})();